module.exports = __webpack_public_path__ + "static/media/search--navy-blue.8fa01977.svg";